import { types } from "../types/types";

const initialState = {

  listFullCatalogSections: [],
  listCatalogSectionsLevel1: [],
  listCatalogSectionsLevel2: [],
  listCatalogSectionsLevel3: [],
  listCatalogSectionsLevel4: [],
  listCatalogSectionsLevel5: [],
  listCatalogSectionsLevel6: [],
  objectCatalogSectionLevel1Selected: {},
  objectCatalogSectionLevel2Selected: {},
  objectCatalogSectionLevel3Selected: {},
  objectCatalogSectionLevel4Selected: {},
  objectCatalogSectionLevel5Selected: {},
  objectCatalogSectionLevel6Selected: {},

  catalogsections_idLevel1: [],
  listCatalogSectionsLevel2: [],
  listCatalogSectionsLevel3: [],
  listCatalogSectionsLevel4: [],
  listCatalogSectionsLevel5: [],
  listCatalogSectionsLevel6: [],
  catalogsection_levelsSelected: {},
  objectCatalogSectionLevel2Selected: {},
  objectCatalogSectionLevel3Selected: {},
  objectCatalogSectionLevel4Selected: {},
  objectCatalogSectionLevel5Selected: {},
  objectCatalogSectionLevel6Selected: {},

  catalogSectionAllLevel6: [],

  catalogSection: {},
  catalogSections: [],
  catalogSectionsP: [],
  catalogSectionsS: [],

  totalItemsP: 0,
  totalPagesP: 0,
  currentPageP: 0,
  
  totalItemsS: 0,
  totalPagesS: 0,
  currentPageS: 0,
  searchTextState: "",
  
  listFullCatalogSectionsNoLevel6: []
};
export const catalogSectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CATALOGSECTION_START_LOADING_LEVEL1:
      return {
        ...state,
        listCatalogSectionsLevel1: action.payload,
      };

    case types.CATALOGSECTION_SELECT_LEVEL1:
      return {
        ...state,
        objectCatalogSectionLevel1Selected: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_LEVEL2:
      return {
        ...state,
        listCatalogSectionsLevel2: action.payload,
      };

    case types.CATALOGSECTION_SELECT_LEVEL2:
      return {
        ...state,
        objectCatalogSectionLevel2Selected: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_LEVEL3:
      return {
        ...state,
        listCatalogSectionsLevel3: action.payload,
      };

    case types.CATALOGSECTION_SELECT_LEVEL3:
      return {
        ...state,
        objectCatalogSectionLevel3Selected: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_LEVEL4:
      return {
        ...state,
        listCatalogSectionsLevel4: action.payload,
      };

    case types.CATALOGSECTION_SELECT_LEVEL4:
      return {
        ...state,
        objectCatalogSectionLevel4Selected: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_LEVEL5:
      return {
        ...state,
        listCatalogSectionsLevel5: action.payload,
      };

    case types.CATALOGSECTION_SELECT_LEVEL5:
      return {
        ...state,
        objectCatalogSectionLevel5Selected: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_LEVEL6:
      return {
        ...state,
        listCatalogSectionsLevel6: action.payload,
      };

    case types.CATALOGSECTION_SELECT_LEVEL6:
      return {
        ...state,
        objectCatalogSectionLevel6Selected: action.payload,
      };

    case types.CATALOGSECTION_CLEAN_LEVEL1:
      return {
        ...state,
        objectCatalogSectionLevel2Selected: {},
        listCatalogSectionsLevel2: [],
        objectCatalogSectionLevel3Selected: {},
        listCatalogSectionsLevel3: [],
        objectCatalogSectionLevel4Selected: {},
        listCatalogSectionsLevel4: [],
        objectCatalogSectionLevel5Selected: {},
        listCatalogSectionsLevel5: [],
        objectCatalogSectionLevel6Selected: {},
        listCatalogSectionsLevel6: [],
      };

    case types.CATALOGSECTION_CLEAN_LEVEL2:
      return {
        ...state,
        objectCatalogSectionLevel3Selected: {},
        listCatalogSectionsLevel3: [],
        objectCatalogSectionLevel4Selected: {},
        listCatalogSectionsLevel4: [],
        objectCatalogSectionLevel5Selected: {},
        listCatalogSectionsLevel5: [],
        objectCatalogSectionLevel6Selected: {},
        listCatalogSectionsLevel6: [],
      };

    case types.CATALOGSECTION_CLEAN_LEVEL3:
      return {
        ...state,
        objectCatalogSectionLevel4Selected: {},
        listCatalogSectionsLevel4: [],
        objectCatalogSectionLevel5Selected: {},
        listCatalogSectionsLevel5: [],
        objectCatalogSectionLevel6Selected: {},
        listCatalogSectionsLevel6: [],
      };

    case types.CATALOGSECTION_CLEAN_LEVEL4:
      return {
        ...state,
        objectCatalogSectionLevel5Selected: {},
        listCatalogSectionsLevel5: [],
        objectCatalogSectionLevel6Selected: {},
        listCatalogSectionsLevel6: [],
      };

    case types.CATALOGSECTION_CLEAN_LEVEL5:
      return {
        ...state,
        objectCatalogSectionLevel6Selected: {},
        listCatalogSectionsLevel6: [],
      };

    /* Esto no esta todavia */
    case types.CATALOGSECTION_UPDATE:
      if (state.catalogSectionsS.length > 0) {
        return {
          ...state,
          catalogSectionsS: state.catalogSectionsS.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
          catalogSectionsP: state.catalogSectionsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      } else {
        return {
          ...state,
          catalogSectionsP: state.catalogSectionsP.map((usr) =>
            usr.id === action.payload.id ? action.payload : usr
          ),
        };
      }

    case types.CATALOGSECTION_DELETE:
      if (state.catalogSectionsS.length > 0) {
        return {
          ...state,
          catalogSectionsS: state.catalogSectionsS.filter((usr) => usr.id !== action.payload),
          catalogSectionsP: state.catalogSectionsP.filter((usr) => usr.id !== action.payload),
          catalogSection: {},
        };
      } else {
        return {
          ...state,
          catalogSectionsP: state.catalogSectionsP.filter((usr) => usr.id !== action.payload),
          catalogSection: {},
        };
      }

    case types.CATALOGSECTION_START_LOADING_PAGINATED:
      return {
        ...state,
        catalogSectionsP: action.payload.catalogSectionsP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.CATALOGSECTION_START_SEARCH:
      return {
        ...state,
        catalogSectionsS: action.payload,
      };

    case types.CATALOGSECTION_START_SEARCH_PAGINATED:
      return {
        ...state,
        catalogSectionsP: action.payload.catalogSectionsP,
        totalItemsS: action.payload.totalItems,
        totalPagesS: action.payload.totalPages,
        currentPageS: action.payload.currentPage,
      };

    case types.CATALOG_CLEAN_SEARCH_PAGINATED:
      return {
        ...state,
        catalogSectionsS: [],
      };

      /*Add */
    case types.CATALOGSECTION_SELECT:
      return {
        ...state,
        catalogSection: action.payload,
      };

    case types.CATALOGSECTION_CLEAN:
      return {
        ...state,
        catalogSection: {},
      };

    case types.CATALOGSECTION_START_REGISTER:
      return {
        ...state,
        catalogSection: action.payload,
      };

    case types.CATALOGSECTION_SET_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: action.payload,
      };

    case types.USER_CLEAN_SEARCH_TEXT:
      return {
        ...state,
        searchTextState: "",
      };

    case types.CATALOGSECTION_START_LOADING_ALL_LEVEL6:
      return {
        ...state,
        catalogSectionAllLevel6: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_ALL:
      return {
        ...state,
        listFullCatalogSections: action.payload,
      };

      case types.CATALOGSECTION_START_LOADING_NO_LEVEL6:
      return {
        ...state,
        listFullCatalogSectionsNoLevel6: action.payload,
      };

    case types.CATALOGSECTION_START_LOADING_FILTER:

      if (action.payload == null || typeof action.payload !== 'object') {
        return state;
      }

      const { catalogsection_level1_codes } = action.payload;

      const catalogSectionIdsList = catalogsection_level1_codes && catalogsection_level1_codes.split(",");

      return {
        ...state,

        listSectionsFilter: getFilterCatalog(state.listCatalogSectionsLevel1, catalogSectionIdsList),

      };

    default:
      return state;
  }
};

const getFilterCatalog = (arrayFull, uniqueArray) => {
  
  let listFilterCatalog = [];

  if (uniqueArray) {

    for (const idUniqueFound of uniqueArray) {
      
      for (const elemSearch of arrayFull) {
        
        const codeFirstLetter = elemSearch.code && elemSearch.code.substring(0, 1);
        if (idUniqueFound === codeFirstLetter) {
          
          elemSearch.isChecked = false;
          listFilterCatalog.push(elemSearch);
        }
      }
    }
  }

  listFilterCatalog.sort((a, b) => a.id - b.id)

  return listFilterCatalog;
}